// Ajustes de audio por participante da sala de voz (volume e gate). Ficam no
// localStorage e sao chaveados por USUARIO, nao por peerId: peerId muda a cada
// reconexao, entao chavear por ele perderia o ajuste justamente quando ele
// importa. Compartilhado entre Sala.js (UI de controles no tile) e
// SalaAudioSink (elementos de audio persistentes que sobrevivem a troca de
// aba dentro do portal).

export const CHAVE_AUDIO = 'siti_sala_audio';
export const AUDIO_PADRAO = { volume: 1, gate: false, sensibilidade: 50 };

export function lerAjustesAudio() {
  try {
    const bruto = JSON.parse(localStorage.getItem(CHAVE_AUDIO) || '{}');
    return bruto && typeof bruto === 'object' ? bruto : {};
  } catch (_) {
    return {};
  }
}

export function gravarAjustesAudio(ajustes) {
  try {
    localStorage.setItem(CHAVE_AUDIO, JSON.stringify(ajustes));
  } catch (_) { /* modo anonimo / cota cheia: segue sem persistir */ }
}

// `autoPlay` so vale quando o elemento MONTA ja com fonte. Como aqui o
// srcObject e atribuido depois, por efeito, e o React reaproveita o mesmo
// no entre reconexoes, o elemento pode ficar `paused` para sempre: a faixa
// chega, o volume esta certo, e mesmo assim nao sai som. Medido em teste:
// paused=true e readyState=0 por 24s seguidos, sem se recuperar sozinho.
//
// Chamar play() na mao depois de cada troca de fonte resolve. A promise pode
// rejeitar (politica de autoplay) — nesse caso vale registrar, porque o
// sintoma para o usuario e silencio sem nenhuma pista.
export function tocar(el, rotulo) {
  if (!el) return;
  const p = el.play();
  if (p && typeof p.catch === 'function') {
    p.catch((err) => {
      console.warn(`[sala] nao consegui tocar o audio de ${rotulo || 'participante'}:`, err?.name || err);
    });
  }
}
